/* Full-index product search. Shopify still renders product cards and handles cart operations. */
(() => {
'use strict';
function paramsFromURL(url){
 const p=new URLSearchParams();let q=url.searchParams.get('q')||'';
 const legacy=q.match(/^product_type:(.+?)(?:\s+AND\s+(.*))?$/i);
 if(legacy){p.append('filter.p.product_type',legacy[1].replace(/^"|"$/g,''));q=legacy[2]||'';}
 p.set('q',q);p.set('type','product');
 for(const value of url.searchParams.getAll('filter.p.product_type'))if(value)p.append('filter.p.product_type',value);
 const sort=url.searchParams.get('audit_sort')||url.searchParams.get('sort_by')||(url.searchParams.get('view')==='ascending'?'created-ascending':'created-descending');
 p.set('audit_sort',['created-descending','created-ascending','manual','best-selling','relevance','title-ascending','title-descending','price-ascending','price-descending'].includes(sort)?sort:'created-descending');return p;
}
async function readJSON(url,signal,crossOrigin=false){
 for(let attempt=0;attempt<2;attempt++){
  const local=new AbortController(),abort=()=>local.abort();signal.addEventListener('abort',abort,{once:true});
  if(signal.aborted)abort();const timer=setTimeout(abort,20000);
  try{
   const r=await fetch(url,{signal:local.signal,credentials:crossOrigin?'omit':'same-origin',cache:'no-store'});
   if(!r.ok){const e=new Error('Request failed ('+r.status+').');e.retryable=[429,500,502,503,504].includes(r.status);throw e;}
   return await r.json();
  }catch(e){if(signal.aborted)throw new DOMException('Cancelled','AbortError');if(attempt===1||e.retryable===false)throw e;}
  finally{clearTimeout(timer);signal.removeEventListener('abort',abort);}
 }
}
function mount(root){
 if(root.cloudSearch)return;
 const form=root.querySelector('[data-cloud-form]'),query=root.querySelector('[data-cloud-query]'),sort=root.querySelector('[data-cloud-sort]'),filters=root.querySelector('[data-cloud-filters]'),clear=root.querySelector('[data-cloud-clear]'),grid=root.querySelector('[data-cloud-grid]'),status=root.querySelector('[data-cloud-status]'),more=root.querySelector('[data-cloud-more]');
 const installedStyles=new Set();
 let session=null;const settings=JSON.parse(root.dataset.sectionSettings||'{}');
 let endpoint;try{endpoint=new URL(root.dataset.endpoint);if(endpoint.protocol!=='https:')throw Error();endpoint.pathname='/api/search';endpoint.search='';}catch{status.textContent='Search is not configured. Please contact the store.';return;}
 const current=s=>session===s&&root.isConnected&&!s.controller.signal.aborted;
 function renderFilters(data,s){
  const fragment=document.createDocumentFragment();
  for(const f of data){const label=document.createElement('label');label.className='dluxca-cloud-filter';
   const input=document.createElement('input');input.type='checkbox';input.setAttribute('form',form.id);input.name='filter.p.product_type';input.value=f.value;input.checked=!!f.selected;
   const title=document.createElement('span');title.textContent=f.label;const count=document.createElement('span');count.textContent=f.count;
   label.append(input,title,count);fragment.append(label);
  }
  filters.replaceChildren(fragment);clear.hidden=!s.params.getAll('filter.p.product_type').length;
 }
 function cardURL(item){
  const source=new URL(item.url);if(!source.pathname.startsWith('/products/'))throw Error('Invalid product link');
  const path=(window.Shopify?.routes?.root||'/')+source.pathname.slice(1),url=new URL(path,location.origin);
  url.searchParams.set('view','dluxca-date-card');
  const page=new URL(location.href);for(const k of ['preview_theme_id','_fd','pb'])if(page.searchParams.has(k))url.searchParams.set(k,page.searchParams.get(k));
  return url;
 }
 async function load(s){
  if(!current(s)||s.busy)return;s.busy=true;more.hidden=true;grid.setAttribute('aria-busy','true');
  status.textContent=s.shown?'Loading more products…':'Searching products…';
  try{
   if(!s.pending){
    const url=new URL(endpoint);url.searchParams.set('q',s.params.get('q'));url.searchParams.set('sort',s.params.get('audit_sort'));
    for(const t of s.params.getAll('filter.p.product_type'))url.searchParams.append('filter.p.product_type',t);
    if(s.cursor)url.searchParams.set('cursor',s.cursor);
    const data=await readJSON(url,s.controller.signal,true);if(!current(s))return;
    if(!Array.isArray(data.items)||data.items.length>24||!Array.isArray(data.filters)||!Number.isInteger(data.total))throw Error('Search returned an unreadable response');
    s.pending=data;renderFilters(data.filters,s);
    for(const option of sort.options){
     if(option.value.startsWith('price-')||option.value==='manual')option.disabled=!data.sort_availability?.prices;
     if(option.value==='best-selling')option.disabled=!data.sort_availability?.best_selling;
    }
   }
   const data=s.pending,html=new Array(data.items.length);let next=0;
   const failures=[];
   await Promise.all(Array.from({length:Math.min(4,data.items.length)},async()=>{
    while(next<data.items.length){const i=next++,item=data.items[i];
     try{
      if(!s.cards.has(item.id)){
       const card=await readJSON(cardURL(item),s.controller.signal);
       if(String(card.id)!==String(item.id)||typeof card.html!=='string')throw Error('Product card unavailable');
       const template=document.createElement('template');template.innerHTML=card.html;
       const productCards=[...template.content.children].filter(n=>n.classList.contains('product-item'));
       if(productCards.length!==1)throw Error('Product card unavailable');
       for(const style of template.content.querySelectorAll('style'))s.styles.add(style.textContent);
       s.cards.set(item.id,productCards[0].outerHTML);
      }
      html[i]=s.cards.get(item.id);
     }catch(e){failures.push(e);}
    }
   }));
   if(!current(s))return;if(failures.length)throw failures[0];
   const fragment=document.createDocumentFragment();
   for(let i=0;i<html.length;i++){
    const item=data.items[i];if(s.ids.has(item.id))continue;
    const template=document.createElement('template');template.innerHTML=html[i];const card=template.content.firstElementChild;
    card.className='product-item product-item--vertical '+(settings.gridClasses||'1/2--phone 1/3--tablet 1/4--lap-and-up');
    card.querySelectorAll('[data-secondary-action="open-quick-view"]').forEach(b=>b.setAttribute('aria-controls','modal-quick-view-'+root.dataset.sectionId));
    fragment.append(template.content);s.ids.add(item.id);
   }
   for(const css of s.styles){if(!installedStyles.has(css)){const style=document.createElement('style');style.textContent=css;root.append(style);installedStyles.add(css);}}
   grid.append(fragment);s.shown=s.ids.size;s.cursor=data.next_cursor;s.pending=null;s.failed=false;
   renderFilters(data.filters,s);status.textContent=data.total?`Showing ${s.shown} of ${data.total} products`:'No matching products. Try another search or clear filters.';
   more.textContent='View more';more.hidden=!s.cursor;
   if(s.trackFilter){
    s.trackFilter=false;
    try{window.DluxcaUsage?.track('search_filter_applied','success');}catch(_){}
   }
   grid.dispatchEvent(new CustomEvent('dluxca:cards-loaded',{bubbles:true}));
  }catch(e){if(current(s)){s.failed=true;status.textContent=s.pending?'Product details could not be loaded. Please retry.':'Search could not be loaded. Please retry.';more.textContent='Retry';more.hidden=false;console.warn('DLUXCA search:',e.message);}}
  finally{s.busy=false;if(current(s))grid.removeAttribute('aria-busy');}
 }
 function start(params,push,trackFilter=false){
  session?.controller.abort();
  if(push){const url=new URL(location.href);for(const k of [...url.searchParams.keys()])if(k.startsWith('filter.')||['q','type','audit_sort','sort_by','page','cursor','audit_page','section_id'].includes(k))url.searchParams.delete(k);
   for(const [k,v] of params)url.searchParams.append(k,v);history.pushState({},'',url);
  }
  session={params,trackFilter,controller:new AbortController(),cursor:null,pending:null,shown:0,ids:new Set(),cards:new Map(),styles:new Set(),busy:false,failed:false};
  query.value=params.get('q');sort.value=params.get('audit_sort');grid.replaceChildren();
  const selected=params.getAll('filter.p.product_type');filters.querySelectorAll('input').forEach(i=>i.checked=selected.includes(i.value));clear.hidden=!selected.length;
  load(session);
 }
 function submit(trackFilter=false){const p=new URLSearchParams(new FormData(form));start(p,true,trackFilter);}
 function filterTrackingAllowed(){try{return window.DluxcaUsageEnabled===true&&!window.Shopify?.designMode&&window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;}catch{return false;}}
 form.addEventListener('submit',e=>{if(e.target!==form)return;e.preventDefault();submit();});
 root.addEventListener('change',e=>{if(e.target.matches('[name="filter.p.product_type"],[data-cloud-sort]'))submit(e.target.matches('[name="filter.p.product_type"]')&&e.target.checked&&filterTrackingAllowed());});
 clear.addEventListener('click',()=>{filters.querySelectorAll('input').forEach(i=>i.checked=false);submit();});
 more.addEventListener('click',()=>load(session));
 const pop=()=>start(paramsFromURL(new URL(location.href)),false);window.addEventListener('popstate',pop);
 root.cloudSearch={destroy(){session?.controller.abort();window.removeEventListener('popstate',pop);}};
 pop();
}
function boot(){document.querySelectorAll('[data-dluxca-cloud-search]').forEach(mount);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',boot);
document.addEventListener('shopify:section:unload',e=>e.target.querySelector('[data-dluxca-cloud-search]')?.cloudSearch?.destroy());
})();
